import React from "react";
import PropTypes from "prop-types";

import { Anchor, Form } from "..";

export function VerifyCodeInput({ disabled, onResendCode }) {
  return (
    <React.Fragment>
      <Form.Input
        name="code"
        label="Verification Code"
        fluid
        defaultValue=""
        placeholder="Enter code"
        disabled={disabled}
      />
      <div
        data-test="resend-container"
        style={{ textAlign: "center", width: "100%" }}
      >
        Didn&apos;t get your code?{" "}
        <Anchor disabled={disabled} onClick={onResendCode}>
          Resend code
        </Anchor>
      </div>
    </React.Fragment>
  );
}

VerifyCodeInput.propTypes = {
  disabled: PropTypes.bool,
  onResendCode: PropTypes.func.isRequired,
};

VerifyCodeInput.defaultProps = {
  disabled: false,
};

export default VerifyCodeInput;
